<template>
  <section>
    <div
      class="tw:flex tw:flex-col tw:md:flex-row tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[480px] tw:max-w-[300px] tw:md:py-4 tw:lg:px-0 tw:mx-auto tw:py-4"
    >
      <div class="tw:flex tw:flex-col tw:md:flex-row tw:w-full tw:gap-4 tw:md:gap-6 tw:lg:gap-11 tw:md:items-end">
        <div class="tw:flex tw:justify-center tw:items-center">
          <img :src="StudioPromo" alt="trivago" class="tw:w-[150px] tw:md:min-w-[145px] tw:lg:min-w-[235px]" />
        </div>
        <div class="tw:flex tw:flex-col tw:items-center tw:md:items-start">
          <div
            class="tw:bg-red-700 tw:text-white tw:text-xs tw:lg:text-sm tw:font-bold tw:px-2 tw:py-1 tw:rounded-tl-xl tw:rounded-br-xl tw:mb-2 tw:uppercase"
          >
            {{ $t('best_value_tag') }}
          </div>
          <p
            class="tw:text-center tw:md:text-left tw:text-sm tw:md:text-base tw:lg:text-xl tw:mb-4"
            v-html="$t('studio_plus_mp_key_message')"
          />
          <MainButton @click="onLoginClick" class="tw:lg:flex tw:hidden">{{ $t('studio_plus_start_cta') }}</MainButton>
          <MainButton @click="onLoginClick" size="medium" class="tw:flex tw:lg:hidden">{{
            $t('studio_plus_start_cta')
          }}</MainButton>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import MainButton from '@/components/base/buttons/MainButton.vue'
import appAnalytics from '@/utils/tracking'

const StudioPromo = new URL('/src/assets/img/studio-plus-landing/studio_plus_promo.png', import.meta.url)

const emit = defineEmits(['onLoginClick'])
const onLoginClick = e => {
  appAnalytics.track(appAnalytics.events.SP_GET_STARTED_BTN_LANDING_CLICKED, { source: 'Great Value Banner' })
  emit('onLoginClick', e.target.value)
}
</script>
